import React from "react"
import { AlertMessage, AssetMap, Hole } from "../../types"

interface HoleHeaderProps {
  hole: Hole,
  assets: AssetMap,
  unsavedScores: boolean,
  prevHole(),
  nextHole(),
  showAlert: (message: AlertMessage) => void,
  saveScores: (afterSave?: () => void) => void
}

export default function HoleHeader({ hole, assets, unsavedScores, prevHole, nextHole, showAlert, saveScores }: HoleHeaderProps) {
  const goTo = (action) => {
    if(unsavedScores) {
      showAlert({
        title: "Scores Not Saved",
        message: "You have entered scores on this hole that you haven't saved. Do you want to save these scores?",
        buttons: [
          { text: "Yes", style: "primary", onPress: () => saveScores(action) },
          { text: "No", onPress: action },
        ]
      })
    } else {
      action()
    }
  }

  return (
    <div className="hole-score-header">
      <div className="left">
        <a onClick={() => goTo(prevHole)}>
          <img src={assets.arrowLeft} style={{ maxWidth: "20px" }} alt="<" />
        </a>
      </div>
      <div className="main">
        <h1 style={{ marginTop: "20px" }}>Hole {hole.number}</h1>
        <p style={{ padding: "5px 0" }}>Par {hole.par} - {hole.yards} Yards</p>
      </div>
      <div className="right">
        <a onClick={() => goTo(nextHole)}>
          <img src={assets.arrowRight} style={{ maxWidth: "20px"}} alt=">" />
        </a>
      </div>
    </div>
  )
}
